export default __webpack_public_path__ + "static/media/freshGinger.a5c6e5e7.jpeg";